import Content from '../../../../components/Content';

import logo from '../../../../assets/img/sheep-orange.jpeg';

import { Container, GradientBackground } from './styles';

const Logo = () => {
  return (
    <Container>
      <Content>
        <h1>Histórico</h1>
      </Content>
      {/* <GradientBackground /> */}
    </Container>
  );
};

export default Logo;
